import { render, staticRenderFns } from "./OrderPollingAdd.vue?vue&type=template&id=4a146030&"
import script from "./OrderPollingAdd.vue?vue&type=script&lang=ts&"
export * from "./OrderPollingAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports